module.exports = __webpack_public_path__ + "img/logo.230f4fab.png";